import { LoadingStatus, QuickSearchResponseData } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { Progress, SearchResultsSection } from '@components';
import { Box, Container, Grid, Skeleton, styled } from '@mui/material';
import { breakpoints, spacing } from '@themes/theme.helpers';
import { t } from '@translations';

// Components & styles
const ResultSummaryBox = styled(Box)`
  padding: ${spacing(1)};
  ${breakpoints.up('md')} {
    padding: ${spacing(2)} ${spacing(2)} ${spacing(4)} ${spacing(2)};
  }
`;

export type QuickSearchResultsProps = {
  searchId: string;
  data?: QuickSearchResponseData;
  status?: LoadingStatus;
};

export const QuickSearchResults = ({ data, status = {} }: QuickSearchResultsProps) => {
  const { isLoading, isFetching } = status;
  return (
    <Box>
      <Grid container spacing={{ xs: 1, md: 8 }}>
        <Grid item xs={12} md={6}>
          <SearchResultsSection
            section='products'
            data={data?.products}
            status={status}
            title={TextCodes.Search.ProductsTab}
            limit={10}
            showImages
            showPrices
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <SearchResultsSection
            section='articles'
            data={data?.articles}
            status={status}
            title={TextCodes.Search.ArticlesTab}
            limit={3}
          />
          <SearchResultsSection
            section='documents'
            data={data?.documents}
            status={status}
            title={TextCodes.Search.DocumentTab}
            limit={3}
            download={true}
          />
        </Grid>
      </Grid>
      <ResultSummaryBox>
        {isLoading && <Skeleton />}
        {isFetching && (
          <>
            <Progress size={16} /> {t(TextCodes.Base.Loading)}
          </>
        )}
      </ResultSummaryBox>
    </Box>
  );
};
export type SearchResultsHintProps = {
  currentSearch?: string;
  status?: LoadingStatus;
};

export const SearchResultsHint = ({ currentSearch, status = {} }: SearchResultsHintProps) => {
  const emptySearch = !currentSearch || currentSearch?.length < 3;
  const { isFetching } = status;
  return (
    <Container>
      {emptySearch && <Box sx={{ py: 2 }}>Type at least 3 characters to search</Box>}
      {!emptySearch && (
        <Box sx={{ py: 2 }}>
          Searching for: {currentSearch} {isFetching && <Progress size={16} />}
        </Box>
      )}
    </Container>
  );
};
